import { createAction } from "@reduxjs/toolkit";

/* This action is performed by the sim reducer */
export const removeSolutionFromTube = createAction<{
  id: string;
  solution: string;
}>("REMOVE_SOLUTION_FROM_TUBE");
